import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import './examples-card.scss';

class ExamplesCard extends PureComponent {
  render() {
    return (
      <div className="examples-card">
        <div
          className="examples-card-image"
          style={{ backgroundImage: `url(${this.props.previewImage})` }}
        />

        <h3
          className="examples-card-title"
          dangerouslySetInnerHTML={{ __html: this.props.title }}
        />

        <p
          className="examples-card-text"
          dangerouslySetInnerHTML={{ __html: this.props.previewText }}
        />

        <div className="examples-card-button">
          <Link
            className="btn btn-arrowed"
            to={this.props.fileLink}
            target="_blank"
          >
            {this.props.buttonLabel}
            <span className="icon">→</span>
          </Link>
        </div>
      </div>
    );
  }
}

ExamplesCard.propTypes = {
  id: PropTypes.number,
  previewImage: PropTypes.string,
  title: PropTypes.string,
  previewText: PropTypes.string,
  fileLink: PropTypes.string,
  buttonLabel: PropTypes.string
};

export default ExamplesCard;



// WEBPACK FOOTER //
// ./src/components/Examples/ExamplesCard.js